import { createSlice } from "@reduxjs/toolkit";
import { getRequest, getMockyRequest } from "services/axiosBaseClient";

const axios = require("axios");
const API_URL = "https://jsonplaceholder.typicode.com/todos";

export const todoSlide = createSlice({
  name: "siteList",
  initialState: {
    data: [],
  },
  reducers: {
    fetchSiteList: (state, action) => {
      state.data = action.payload;
    },
    // ,
    // getTodo: (state, action) => {
    //   state.data = [action.payload];
    // }
  },
});

// export const getTodoAsync = (data) => async (dispatch) => {
//   try {
//     const response = await axios.get(`${API_URL}/${data}`);
//     dispatch(getTodo(response.data));
//   } catch (err) {
//     throw new Error(err);
//   }
// };

export const addTodoAsync = (data) => async (dispatch) => {
  try {
    getRequest("sites/evses")
      .then((response) => {
        // getMockyRequest('https://run.mocky.io/v3/faaeee29-5827-4087-a0ce-c0f466e95693').then((response) => {

        if (response.status === 200) {
          let dataArray = response?.data?.siteEvse;
          let siteArray = [
            { label: "Select All", value: "0", evseId: "", siteID: "" },
          ];
          dataArray?.map((item) => {
            if (item.site.name !== undefined) {
              siteArray.push({
                label:
                  item?.site?.address?.street +
                  " " +
                  item?.site?.address?.region +
                  " " +
                  item?.site?.address?.countryCode,
                value: item?.evseId,
                address: item.site.address,
                evseId: item?.evseId,
                siteID: item?.site?.siteId,
                name: "site",
              });
            }
          });

          dispatch(fetchSiteList(siteArray));
        } else {
          return ["vaibhav"];
        }
      })
      .catch((err) => {
        console.error("Error Redux", err);
      });
  } catch (err) {
    throw new Error(err);
  }
};

export const getChargerAndEvseAsync = (cb) => async (dispatch) => {
  try {
    getRequest("sites/evses")
      .then((response) => {
        if (response.status === 200) {
          cb(response.data);
        } else {
        }
      })
      .catch((err) => {
        console.error("Error Redux", err);
      });
  } catch (err) {
    throw new Error(err);
  }
};

export const { fetchSiteList } = todoSlide.actions;
export const getSiteList = (state) => state?.siteList?.data;
export default todoSlide.reducer;
